import resourcesSessionLoader from "../../../resources/session-loader"

export function loadRequestFormsCollectionMissingData(requestFormsData:JSONArray) {

    const sessionLoaderPromise = resourcesSessionLoader(findMissingData(requestFormsData))
    return sessionLoaderPromise
}

function findMissingData(requestFormsData:any[]) {
    let allProjects     : ID[] = []
    let allTaskTypes    : ID[] = []
    let allUsers        : ID[] = []
    let allCustomFields : ID[] = []

    _.map(requestFormsData, config=>{
        if (config.projectId)           allProjects.push(config.projectId)
        if (config.taskTypeId)          allTaskTypes.push(config.taskTypeId)
        if (config.assignToUserId)      allUsers.push(config.assignToUserId)

        _.map(config.settings?.fields, (formField:any)=>{
            if (formField.taskFieldId && !gd.fields.task.hasField(formField.taskFieldId)) {
                allCustomFields.push(formField.taskFieldId)
            }
        })
    })

    return gd.session.findMissing({
        users           : _.uniq(allUsers),
        taskTypes       : _.uniq(allTaskTypes),
        projects        : _.uniq(allProjects),
        customFields    : _.uniq(allCustomFields),
    })
}